import React, { Component } from "react";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import format from "date-fns/format";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../landing/css/style_center.css";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { openModal } from "../../../actions/modalAction";
import { Icon, Modal, Popup } from "semantic-ui-react";
import PropResiEdit from "./PropResiEdit";
import PropResiDetail from "./PropResiDetail";
import PropResiCreateDuplicate from "./PropResiCreateDuplicate";
import Confirm from "../../common/Confirm_1";
import Img from "../../landing/img/noImg.jpg";
import { imageDomain,multipleImageURL } from "../../configC/keys";
import HorizontalScroll from "../../common/HorizontalScrollReact/HorizontalScroll";
import {
  renderWhatsappButton,
  renderPhoneButton,
  renderSmsButton,
} from "../../functions/Functions";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { RiImageAddLine } from "react-icons/ri";
import { IoDuplicateOutline } from "react-icons/io5";

class PropResiSummary extends Component {
  state = {
    detailModalOpen: false,
    editModalOpen: false,
    createDuplicateModalOpen: false,
    open: false,
    id: "",
    paths:[],
  };

  //^^^^^^^^^^^^^^^
  show = (id,paths) => {
    this.setState({ open: true, id: id, paths:paths });
  };

  //******************* */
  handleConfirm = async () => {
    const did = this.state.id;
    const paths = this.state.paths;
    const imageURL = multipleImageURL;

    const imgRoute = "api/ImageDeleteBulk";
    

    //************
    try {
      // ^^^^^^^^^^^^^^^
      const resImage = await axios.post(`${imageURL}/${imgRoute}`, { paths });
      //^^^^^^^^^^^^^^^^^
      if (resImage.data.msg === "success") {
      const res = await axios.put(`/api/dwk/PropResiDelete/${did}`);
      if (res.data.msg === "success") {
        this.props.handleRefresh();
        this.setState({ open: false });
        toastr.success("Deleted Successfully");
      }
    };
      
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        toastr.error("Oops", "Something went wrong.Please Try Again");
      }
    }
    //**********
  };

  handleCancel = () => this.setState({ open: false });
  //**********************************
  handleEditModalOpen = (id, companyId) =>
    this.setState({ editModalOpen: true, id: id, companyId });
  handleEditModalClose = () => {
    this.setState({ editModalOpen: false });
  }; //
  handleEditModalCloseSubmit = () => {
    this.props.handleRefresh();
    this.setState({ editModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  handleDetailModalOpen = (id) =>
    this.setState({ detailModalOpen: true, id: id });
  handleDetailModalClose = () => this.setState({ detailModalOpen: false });
  // ^^^^^^^^^^^
  handleCreateDuplicateModalOpen = (id) =>
    this.setState({ createDuplicateModalOpen: true, id: id });
  handleCreateDuplicateModalClose = () =>
    this.setState({ createDuplicateModalOpen: false });
  //**************** */
  handleCreateImagesModal = (id) => {
    this.props.openModal("CreateImagesModal", {
      id: id,
      imgRoute: "addImageProp",
      apiRoute: "/api/dwk/PropResiEditForAddImagePath",
      handleRefresh: this.props.handleRefresh,
    });
  };
  //@@
  handleOpenModalImage = (id, images) => {
    this.props.openModal("ShowImagesForEditModal", {
      id: id,
      images: images,
      // msg:msg,
      //imgRoute : '/api/ImageDeleteBulk',
      apiRoute: "/api/dwk/PropResiEditForAddImagePath",
      handleRefresh: this.props.handleRefresh,
    });
  };
  //^^^^^^^^^^^^^^^^^^
  handleOpenModalVideo = (videoPath) => {
    this.props.openModal("ShowVideoModal", { videoPath });
  };
  //****** */
  //^^^^^^^^^^^^^^^
  renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };

  //*******************************************************

  renderPropertySummary = () => {
    const {
      videoPath,
      imagePaths,
      _id,
      propertyFor,
      // category,
      propertyType,
      areaPlot,
      areaPlotUnit,
      bedroom,
      bathroom,
      balcony,
      additionalRooms,
      furnishedStatus,
      expectedPrice,
      expectedRent,
      entry,
      floorNo,
      // showFloorNo,
      // status,
      projectName,
      // projectType,
      locality,
      // locationOnMap,
      //createdAt,
      phoneOfContactPerson,
    } = this.props.propresi;

    const renderadditionalRooms = () => {
      return additionalRooms.map((item, index) => {
        // if(additionalRooms.length >1){
        return (
          <span key={item}>
            {item}
            {additionalRooms.length - 1 === index ? "" : " +"}{" "}
          </span>
        );
        // }else{
        // return <span key={item}>{item} </span>;
        // }
      });
    };

    // const daysAgo = Math.round((Date.now()-Date.parse(createdAt))/(24*60*60*1000));

    const renderDeleteButton = () => (
      <Popup
        content={"Delete"}
        disabled={this.renderPopupState()}
        trigger={
          <span onClick={() => this.show(_id, imagePaths)} className="ml-05">
            <RiDeleteBin5Line
              className="icon-gr"
              style={{ backgroundColor: "red" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^^
    const renderEditButton = () => (
      <Popup
        content={"Edit"}
        disabled={this.renderPopupState()}
        trigger={
          <span onClick={() => this.handleEditModalOpen(_id)} className="ml-05">
            <FaRegEdit
              className="icon-gr"
              style={{ backgroundColor: "dodgerblue" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^^
    const renderCreateDuplicateButton = () => (
      <Popup
        content={"Create Duplicate Property"}
        disabled={this.renderPopupState()}
        trigger={
          <span
            onClick={() => this.handleCreateDuplicateModalOpen(_id)}
            className="ml-05"
          >
            <IoDuplicateOutline
              className="icon-gr"
              style={{ backgroundColor: "teal" }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^
    const renderAddImageButton = () => (
      <Popup
        content={"Add Image"}
        disabled={this.renderPopupState()}
        trigger={
          <span
            onClick={() => this.handleCreateImagesModal(_id)}
            className="ml-05"
          >
            <RiImageAddLine
              className="icon-gr"
              style={{ backgroundColor: "skyblue" }}
            />
          </span>
        }
      />
    );

    //*************** */
    const price = (value) => {
      var val = Math.abs(value);
      if (val >= 10000000) {
        val = (val / 10000000).toFixed(2) + " Cr";
      } else if (val >= 100000) {
        val = (val / 100000).toFixed(2) + " Lac";
      }
      /*else if(val >= 1000) val = (val/1000).toFixed(2) + ' K';*/
      return val;
    };

    const classN = "card-1 direction-r2c";
    const classBG = "card";
    const phone = phoneOfContactPerson || "9910223322";

    const line1 =
      propertyType === "Residential Land /Plot"
        ? ` ${areaPlot} ${areaPlotUnit}`
        : "";
    const line2 =
      propertyType !== "Residential Land /Plot" && bedroom
        ? `${bedroom} BHK`
        : "";
    const line3 = propertyType ? `${propertyType} for ${propertyFor}` : "";
    const line4 = projectName ? `in ${projectName} ` : "";
    const line5 = locality ? `${locality} Dwarka New Delhi` : "";
    const line6 =
      propertyFor === "SALE"
        ? `${expectedPrice > 0 && price(expectedPrice)}`
        : `${expectedRent > 0 && price(expectedRent)}`;
    const msg = `${line1} ${line2} ${line3} ${line4} ${line5} @ Price ${line6}`;
    const message = `Interested in ${msg}`;

    return (
      <div key={_id} style={{ margin: "0px" }}>
        <div
          className={classBG}
          style={{
            padding: "0px",
            borderRadius: "5px",
          }}
        >
          {/* property summary section + image section */}
          <div
            className={classN}
            style={{
              padding: "10px",
              borderRadius: "5px",
            }}
          >
            {/* image section */}
            <div
              className="flex-value-img"
              style={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <span className="ribbon-yp-lt">{propertyFor}</span>
              <div>
                {imagePaths.length > 0 ? (
                  <img
                    className="yimg image-respo"
                    src={`${imageDomain}/${imagePaths[0]}`}
                    alt="Display_Image"
                    width="auto"
                    height="auto"
                  />
                ) : (
                  <img
                    className="yimg image-respo"
                    src={Img}
                    alt="Display_Image"
                    width="100%"
                    height="100%"
                  />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  fontSize: ".75rem",
                  fontWeight: "normal",
                }}
              ></div>
            </div>
            {/*end image section  */}
            {/* property summary section  */}
            <div className="flex-value-summary ">
              <span style={{ marginBottom: "0px" }} className="ribbon-lt2">
                <span>
                  <Icon className="rupee"></Icon>
                  <b>
                    {(propertyFor === "SALE" &&
                      expectedPrice > 0 &&
                      price(expectedPrice)) ||
                      (propertyFor !== "SALE" &&
                        expectedRent > 0 &&
                        price(expectedRent))}
                  </b>
                </span>
              </span>
              <span style={{ marginLeft: "50px" }}>
                {renderWhatsappButton(phone, message)}
              </span>
              <span style={{ marginLeft: "05px" }}>
                {renderPhoneButton(phone)}
              </span>
              <span style={{ marginLeft: "05px" }}>
                {renderSmsButton(phone, message)}
              </span>

              {/* Heading */}
              <div
                style={{
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  fontWeight: "bold",
                  color: "GrayText",
                }}
              >
                {propertyType === "Residential Land /Plot" && (
                  <span className="color-dodgerblue">
                    {areaPlot} {areaPlotUnit}
                  </span>
                )}
                {propertyType !== "Residential Land /Plot" && bedroom && (
                  <span className="color-dodgerblue">{bedroom} BHK</span>
                )}
                {propertyType && (
                  <span>
                    <span className="color-dodgerblue"> {propertyType} </span>
                    <span className="font-14B"> for </span>
                  </span>
                )}{" "}
                {propertyFor && (
                  <span>
                    <span
                      className=""
                      // style={{ color: "rgb(226, 72, 1)" }}
                    >
                      {" "}
                      {propertyFor}{" "}
                    </span>
                  </span>
                )}{" "}
                {projectName && (
                  <span className="">in {projectName} </span>
                )}
                {locality && (
                  <span>
                    {" "}
                    <span>in {locality} Dwarka New Delhi </span>{" "}
                    {/* <a
                      target="_blank"
                      rel="noreferrer noopener"
                      href={`${locationOnMap}`}
                    >
                      <span className="ml-05">
                        {" "}
                        <img
                          className="yimg"
                          src="/mapIcon.png"
                          alt="Location on Map"
                          style={{
                            width: "25px",
                            height: "25px",
                            borderRadius: "5px",
                            verticalAlign: "middle",
                          }}
                        />
                      </span>
                    </a> */}
                  </span>
                )}
              </div>
              {/* Heading end */}
              {/* overview start */}
              {/*  */}
              {/*               
              <div
                style={{
                  margin: "",
                  maxWidth: "350px",
                  maxHeight: "100px",
                  maxHeight: "",
                  flexWrap: "nowrap",
                }}
                className="slider-container"
              >
                <Slider
                  ref={(slider) => {
                    sliderRef1 = slider;
                  }}
                  {...settings}
                >
                  
                  <div>
                    {bathroom && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Bath</b>
                        </div>
                        <div className="main-overview">
                          <b>{bathroom}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {additionalRooms.length > 0 && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Extra Rooms</b>
                        </div>
                        <div className="main-overview">
                          <b>{renderadditionalRooms()}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {balcony && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Balcony</b>
                        </div>
                        <div className="main-overview">
                          <b>{balcony}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {entry && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Entry</b>
                        </div>
                        <div className="main-overview">
                          <b>{entry}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {furnishedStatus && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Furnishing</b>
                        </div>
                        <div className="main-overview">
                          <b>{furnishedStatus}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {floorNo && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Floor No</b>
                        </div>
                        <div className="main-overview">
                          <b>{floorNo}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {projectName && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Complex/ Project Name</b>
                        </div>
                        <div className="main-overview">
                          <b>{projectName}</b>
                        </div>
                      </div>
                    )}
                  </div>
                </Slider>
              </div> */}
              <HorizontalScroll widthVal={"350px"}>
                <div className="flex-start nowrap">
                  <div>
                    {bathroom && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Bath</b>
                        </div>
                        <div className="main-overview">
                          <b>{bathroom}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {additionalRooms.length > 0 && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Extra Rooms</b>
                        </div>
                        <div className="main-overview">
                          <b>{renderadditionalRooms()}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {balcony && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Balcony</b>
                        </div>
                        <div className="main-overview">
                          <b>{balcony}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {entry && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Entry</b>
                        </div>
                        <div className="main-overview">
                          <b>{entry}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {furnishedStatus && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Furnishing</b>
                        </div>
                        <div className="main-overview">
                          <b>{furnishedStatus}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {floorNo && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Floor No</b>
                        </div>
                        <div className="main-overview">
                          <b>{floorNo}</b>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {projectName && (
                      <div className="row-projName  card-overview-summary">
                        <div className="side-overview">
                          <b>Complex/ Project Name</b>
                        </div>
                        <div className="main-overview">
                          <b>{projectName}</b>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </HorizontalScroll>
              <div className="flex-center">
                <div>
                  <span
                    onClick={() => this.handleDetailModalOpen(_id)}
                    className="mr-05 tag-button"
                    style={{ fontSize: "", cursor: "pointer" }}
                  >
                    Detail
                  </span>
                  <span
                    onClick={() => this.handleOpenModalImage(_id, imagePaths)}
                    className="mr-05 tag-button"
                    style={{ fontSize: "", cursor: "pointer" }}
                  >
                    Images
                  </span>
                  <span
                    onClick={() => this.handleOpenModalVideo(videoPath)}
                    className="mr-05 tag-button"
                    style={{ fontSize: "", cursor: "pointer" }}
                  >
                    Video
                  </span>
                </div>
                <div className="mt-10 mb-10">
                  {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_dwk')  &&
                    renderEditButton()}
                  {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_dwk')  &&
                    renderDeleteButton()}
                  {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_dwk')  &&
                    renderAddImageButton()}
                  {this.props.userA !== null &&
                    (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_dwk')  &&
                    renderCreateDuplicateButton()}
                </div>
              </div>
              {/* overview end */}

              <div className="display-flex a-i-center nodisplay ">
                {/* {renderShortRejectAddRemoveButton()}
                {renderShortRejectAddButton()} */}
              </div>
            </div>
            {/* end property summary section  */}
          </div>
        </div>
      </div>
    );
  };

  // **********

  render() {
    return (
      <div>
        <Confirm
          open={this.state.open}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        {/* Edit Modal*/}

        <Modal
          open={this.state.editModalOpen}
          onClose={this.handleEditModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
        >
          <Modal.Content>
            <PropResiEdit
              id={this.state.id}
              handleEditModalCloseSubmit={this.handleEditModalCloseSubmit}
              handleEditModalClose={this.handleEditModalClose}
            />
          </Modal.Content>
        </Modal>
        {/* detail Modal*/}
        <Modal
          open={this.state.detailModalOpen}
          onClose={this.handleDetailModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
          className="ui.dimmer-none"
        >
          <Modal.Content>
            <PropResiDetail
              id={this.state.id}
              handleDetailModalClose={this.handleDetailModalClose}
            />
          </Modal.Content>
        </Modal>

        {/* detail Modal end*/}
        {/* create Duplicate Modal*/}
        <Modal
          open={this.state.createDuplicateModalOpen}
          onClose={this.handleCreateDuplicateModalClose}
          basic
          closeOnEscape={false}
          closeOnDimmerClick={false}
          // size='small'
          className="ui.dimmer-none"
        >
          <Modal.Content>
            <PropResiCreateDuplicate
              id={this.state.id}
              handleCreateDuplicateModalClose={
                this.handleCreateDuplicateModalClose
              }
            />
          </Modal.Content>
        </Modal>

        {/* create Duplicate Modal end*/}

        {this.renderPropertySummary()}
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, {
  openModal,
})(PropResiSummary);
